
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$autocomplete.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$autocomplete.js';
export default __default__;
